export const getTagDiscount = (tags = []) => {
  const discountCode = tags.find((tag) => tag.includes('ssale'));

  if (discountCode) {
    const discountNumber = discountCode.match(/\d+/)[0];

    return parseInt(discountNumber, 10);
  }

  return undefined;
};
